export default [
  {
    path: "/apps/calendar",
    name: "apps-calendar",
    component: () => import("@/views/apps/calendar/Calendar.vue"),
  },
  // {
  //   path: '/search',
  //   name: 'search',
  //   component: () => import('@/views/Complaint/Search.vue'),
  //   meta: {
  //     pageTitle: 'ค้นหา',
  //     breadcrumb: [
  //       {
  //         text: 'ค้นหา',
  //       },
  //       {
  //         text: 'ค้นหาทั้งหมด',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  {
    path: "/Approve",
    name: "Approve",
    component: () => import("@/views/Complaint/approve/Approve.vue"),
    meta: {
      pageTitle: "รายการเอกสาร",
      breadcrumb: [
        {
          text: "รายการเอกสาร",
        },
        {
          text: "รายการรออนุมัติ",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Approve/Manage",
    name: "ApproveManage",
    component: () => import("@/views/Complaint/approve/ApproveManage.vue"),
    meta: {
      pageTitle: "รายการเอกสาร",
      breadcrumb: [
        {
          text: "รายการรออนุมัติ",
        },
        {
          text: "อนุมัติ",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Approve/Confirm",
    name: "ApproveConfirm",
    component: () => import("@/views/Complaint/approve/Confirm.vue"),
    meta: {
      pageTitle: "รายการเอกสาร",
      breadcrumb: [
        {
          text: "รายการรออนุมัติ",
        },
        {
          text: "อนุมัติ",
          active: true,
        },
      ],
    },
  },

  {
    path: "/LeaderDept",
    name: "LeaderDept",
    component: () => import("@/views/Complaint/LeaderDept/LeaderDept.vue"),
    meta: {
      pageTitle: "หัวหน้าทีม",
      breadcrumb: [
        {
          text: "คัดกรอง",
        },
        {
          text: "หัวหน้าทีม",
          active: true,
        },
      ],
    },
  },
  {
    path: "/LeaderDept/Recieve",
    name: "LeaderDeptRecieve",
    component: () =>
      import("@/views/Complaint/LeaderDept/LeaderDeptRecieve.vue"),
    meta: {
      pageTitle: "หัวหน้าทีม",
      breadcrumb: [
        {
          text: "คัดกรอง",
        },
        {
          text: "หัวหน้าทีม",
          active: true,
        },
      ],
    },
  },
  {
    path: "/LeaderDept/Confirm",
    name: "LeaderDeptConfirm",
    component: () =>
      import("@/views/Complaint/LeaderDept/LeaderDeptConfirm.vue"),
    meta: {
      pageTitle: "หัวหน้าทีม",
      breadcrumb: [
        {
          text: "คัดกรอง",
        },
        {
          text: "หัวหน้าทีม",
          active: true,
        },
      ],
    },
  },

  {
    path: "/Officer",
    name: "Officer",
    component: () => import("@/views/Complaint/Officer/Officer.vue"),
    meta: {
      pageTitle: "รายการเรื่องร้องทุกข์",
      breadcrumb: [
        {
          text: "เจ้าหน้าที่",
        },
        {
          text: "รายการเรื่องร้องทุกข์",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Officer/Manage",
    name: "OfficerManage",
    component: () => import("@/views/Complaint/Officer/OfficerManage.vue"),
    meta: {
      pageTitle: "รายการเรื่องร้องทุกข์",
      breadcrumb: [
        {
          text: "เจ้าหน้าที่",
        },
        {
          text: "รายการเรื่องร้องทุกข์",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Officer/GroupManage",
    name: "OfficerGroupManage",
    component: () =>
      import("@/views/Complaint/Officer/OfficerGroupManage.vue"),
    meta: {
      pageTitle: "เจ้าหน้าที่",
      breadcrumb: [
        {
          text: "เจ้าหน้าที่",
        },
        {
          text: "รายการเรื่องร้องทุกข์",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Officer/Confirm",
    name: "OfficerConfirm",
    component: () => import("@/views/Complaint/Officer/OfficerConfirm.vue"),
    meta: {
      pageTitle: "รายการเรื่องร้องทุกข์",
      breadcrumb: [
        {
          text: "เจ้าหน้าที่",
        },
        {
          text: "รายการเรื่องร้องทุกข์",
          active: true,
        },
      ],
    },
  },

  {
    path: "/EditorDom",
    name: "EditorDom",
    component: () => import("@/views/Complaint/EditorDom/EditorDom.vue"),
    meta: {
      pageTitle: "เนื้อหาระบบ",
      breadcrumb: [
        {
          text: "เนื้อหาระบบ",
        },
      ],
    },
  },

  {
    path: "/EditorDom/Manage",
    name: "EditorDomManage",
    component: () => import("@/views/Complaint/EditorDom/EditorDomManage.vue"),
    meta: {
      pageTitle: "เนื้อหาระบบ",
      breadcrumb: [
        {
          text: "เนื้อหาระบบ",
        },
        {
          text: "จัดการเนื้อหาระบบ",
          active: true,
        },
      ],
    },
  },

  {
    path: "/Deptlist",
    name: "Deptlist",
    component: () => import("@/views/Complaint/Deptlist/Deptlist.vue"),
    meta: {
      pageTitle: "ธุรการกอง",
      breadcrumb: [
        {
          text: "คัดกรอง",
        },
        {
          text: "ธุรการกอง",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Deptlist/Recieve",
    name: "DeptlistRecieve",
    component: () => import("@/views/Complaint/Deptlist/DeptlistRecieve.vue"),
    meta: {
      pageTitle: "ธุรการกอง",
      breadcrumb: [
        {
          text: "คัดกรอง",
        },
        {
          text: "ธุรการกอง",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Deptlist/Confirm",
    name: "DeptlistConfirm",
    component: () => import("@/views/Complaint/Deptlist/DeptlistConfirm.vue"),
    meta: {
      pageTitle: "ธุรการกอง",
      breadcrumb: [
        {
          text: "คัดกรอง",
        },
        {
          text: "ธุรการกอง",
          active: true,
        },
      ],
    },
  },

  {
    path: "/search",
    name: "ComplaintMainSearch",
    component: () =>
      import("@/views/Complaint/MainSearch/ComplaintMainSearch.vue"),
    meta: {
      pageTitle: "ค้นหา",
      breadcrumb: [
        {
          text: "ค้นหา",
          active: true,
        },
      ],
    },
  },
  {
    path: "/search/detail",
    name: "ComplaintMainSearchDetail",
    component: () =>
      import("@/views/Complaint/MainSearch/ComplaintMainSearchDetail.vue"),
    meta: {
      pageTitle: "ค้นหา",
      breadcrumb: [
        {
          text: "รายละเอียด",
          active: true,
        },
      ],
    },
  },

  {
    path: "/Screening",
    name: "screening",
    component: () => import("@/views/Complaint/screening/screening.vue"),
    meta: {
      pageTitle: "คัดกรอง",
      breadcrumb: [
        {
          text: "คัดกรอง",
        },
        {
          text: "คัดกรองเรื่องร้องทุกข์",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Screening/Manage",
    name: "ScreeningManage",
    component: () => import("@/views/Complaint/screening/ScreeningManage.vue"),
    meta: {
      pageTitle: "คัดกรอง",
      breadcrumb: [
        {
          text: "คัดกรอง",
        },
        {
          text: "จัดการเรื่องร้องทุกข์",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Screening/GroupManage",
    name: "ScreeningGroupManage",
    component: () =>
      import("@/views/Complaint/screening/ScreeningGroupManage.vue"),
    meta: {
      pageTitle: "คัดกรอง",
      breadcrumb: [
        {
          text: "คัดกรอง",
        },
        {
          text: "จัดการเรื่องร้องทุกข์",
          active: true,
        },
      ],
    },
  },
  {
    path: "/GCC",
    name: "GCC",
    component: () => import("@/views/Complaint/GCC/GCC.vue"),
    meta: {
      pageTitle: "คัดกรอง",
      breadcrumb: [
        {
          text: "คัดกรอง",
        },
        {
          text: "รอบันทึกรับเรื่องร้องทุกข์ GCC1111",
          active: true,
        },
      ],
    },
  },
  {
    path: "/GCC/Received",
    name: "GCCReceived",
    component: () => import("@/views/Complaint/GCC/GCCReceived.vue"),
    meta: {
      pageTitle: "คัดกรอง",
      breadcrumb: [
        {
          text: "คัดกรอง",
        },
        {
          text: "รับเรื่องร้องทุกข์ GCC1111",
          active: true,
        },
      ],
    },
  },
  {
    path: "/GCC/Clue",
    name: "GCCClue",
    component: () => import("@/views/Complaint/GCC/GCCClue.vue"),
    meta: {
      pageTitle: "คัดกรอง",
      breadcrumb: [
        {
          text: "คัดกรอง",
        },
        {
          text: "รับเรื่องร้องทุกข์ GCC1111",
          active: true,
        },
      ],
    },
  },
  {
    path: "/GCC/SendBack",
    name: "GCCSendBack",
    component: () => import("@/views/Complaint/GCC/GCCSendBack.vue"),
    meta: {
      pageTitle: "คัดกรอง",
      breadcrumb: [
        {
          text: "คัดกรอง",
        },
        {
          text: "รับเรื่องร้องทุกข์ GCC1111",
          active: true,
        },
      ],
    },
  },
  {
    path: "/GCC/Acknowledge",
    name: "GCCAcknowledge",
    component: () => import("@/views/Complaint/GCC/GCCAcknowledge.vue"),
    meta: {
      pageTitle: "คัดกรอง",
      breadcrumb: [
        {
          text: "คัดกรอง",
        },
        {
          text: "รับเรื่องร้องทุกข์ GCC1111",
          active: true,
        },
      ],
    },
  },
  {
    path: "/GCC/Manage",
    name: "GCCManage",
    component: () => import("@/views/Complaint/GCC/GCCManage.vue"),
    meta: {
      pageTitle: "คัดกรอง",
      breadcrumb: [
        {
          text: "คัดกรอง",
        },
        {
          text: "รับเรื่องร้องทุกข์ GCC1111",
          active: true,
        },
      ],
    },
  },
  {
    path: "/RequestFile",
    name: "RequestFile",
    component: () => import("@/views/Complaint/requestfile/RequestFile.vue"),
    meta: {
      pageTitle: "ขอเอกสารเพิ่มเติม",
      breadcrumb: [
        {
          text: "คัดกรอง",
        },
        {
          text: "ขอเอกสารเพิ่มเติม",
          active: true,
        },
      ],
    },
  },
  {
    path: "/RequestFile/Manage",
    name: "RequestFileManage",
    component: () =>
      import("@/views/Complaint/requestfile/RequestFileManage.vue"),
    meta: {
      pageTitle: "ขอเอกสารเพิ่มเติม",
      breadcrumb: [
        {
          text: "คัดกรอง",
        },
        {
          text: "ขอเอกสารเพิ่มเติม",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Transfer",
    name: "Transfer",
    component: () => import("@/views/Complaint/transfer/Transfer.vue"),
    meta: {
      pageTitle: "แก้ไขรายชื่อผู้ดูแลข้อมูล",
      breadcrumb: [
        {
          text: "แก้ไขรายชื่อผู้ดูแลข้อมูล",
          active: true,
        },
      ],
    },
  },

  {
    path: "/ComplaintHistory",
    name: "ComplaintHistory",
    component: () =>
      import("@/views/Complaint/ComplaintHistory/ComplaintHistory.vue"),
    meta: {
      pageTitle: "ประวัติทั้งหมด",
      breadcrumb: [
        {
          text: "ประวัติทั้งหมด",
          active: true,
        },
      ],
    },
  },

  {
    path: "/ReceivedHistory",
    name: "ReceivedHistory",
    component: () =>
      import("@/views/Complaint/ReceivedHistory/ReceivedHistory.vue"),
    meta: {
      pageTitle: "ประวัติการรับเรื่อง",
      breadcrumb: [
        {
          text: "ประวัติการรับเรื่อง",
          active: true,
        },
      ],
    },
  },

  {
    path: "/ComplaintHistory/detail",
    name: "ComplaintHistoryDetail",
    component: () =>
      import("@/views/Complaint/ComplaintHistory/ComplaintHistoryDetail.vue"),
    meta: {
      pageTitle: "ค้นหา",
      breadcrumb: [
        {
          text: "รายละเอียด",
          active: true,
        },
      ],
    },
  },

  {
    path: "/LawDeptlist",
    name: "LawDeptlist",
    component: () => import("@/views/Complaint/LawDeptlist/LawDeptlist.vue"),
    meta: {
      pageTitle: "ธุรการกอง",
      breadcrumb: [
        {
          text: "กองกฎหมาย",
        },
        {
          text: "ธุรการกอง",
          active: true,
        },
      ],
    },
  },
  {
    path: "/LawDeptlist/Recieve",
    name: "LawDeptlistRecieve",
    component: () =>
      import("@/views/Complaint/LawDeptlist/LawDeptlistRecieve.vue"),
    meta: {
      pageTitle: "ธุรการกอง",
      breadcrumb: [
        {
          text: "กองกฎหมาย",
        },
        {
          text: "ธุรการกอง",
          active: true,
        },
      ],
    },
  },
  {
    path: "/LawDeptlist/Confirm",
    name: "LawDeptlistConfirm",
    component: () =>
      import("@/views/Complaint/LawDeptlist/LawDeptlistConfirm.vue"),
    meta: {
      pageTitle: "ธุรการกอง",
      breadcrumb: [
        {
          text: "กองกฎหมาย",
        },
        {
          text: "ธุรการกอง",
          active: true,
        },
      ],
    },
  },
  {
    path: "/LawLeaderDept",
    name: "LawLeaderDept",
    component: () =>
      import("@/views/Complaint/LawLeaderDept/LawLeaderDept.vue"),
    meta: {
      pageTitle: "หัวหน้าทีม",
      breadcrumb: [
        {
          text: "กองกฎหมาย",
        },
        {
          text: "หัวหน้าทีม",
          active: true,
        },
      ],
    },
  },
  {
    path: "/LawLeaderDept/Manage",
    name: "LawLeaderDeptManage",
    component: () =>
      import("@/views/Complaint/LawLeaderDept/LawLeaderDeptManage.vue"),
    meta: {
      pageTitle: "หัวหน้าทีม",
      breadcrumb: [
        {
          text: "กองกฎหมาย",
        },
        {
          text: "หัวหน้าทีม",
          active: true,
        },
      ],
    },
  },
  {
    path: "/LawLeaderDept/Confirm",
    name: "LawLeaderDeptConfirm",
    component: () =>
      import("@/views/Complaint/LawLeaderDept/LawLeaderDeptConfirm.vue"),
    meta: {
      pageTitle: "หัวหน้าทีม",
      breadcrumb: [
        {
          text: "กองกฎหมาย",
        },
        {
          text: "หัวหน้าทีม",
          active: true,
        },
      ],
    },
  },
  {
    path: "/LawOfficer",
    name: "LawOfficer",
    component: () => import("@/views/Complaint/LawOfficer/LawOfficer.vue"),
    meta: {
      pageTitle: "รายการเรื่องร้องทุกข์",
      breadcrumb: [
        { text: "กองกฎหมาย" },
        {
          text: "เจ้าหน้าที่",
        },
        {
          text: "รายการเรื่องร้องทุกข์",
          active: true,
        },
      ],
    },
  },
  {
    path: "/LawOfficer/Manage",
    name: "LawOfficerManage",
    component: () =>
      import("@/views/Complaint/LawOfficer/LawOfficerManage.vue"),
    meta: {
      pageTitle: "รายการเรื่องร้องทุกข์",
      breadcrumb: [
        { text: "กองกฎหมาย" },
        {
          text: "เจ้าหน้าที่",
        },
        {
          text: "รายการเรื่องร้องทุกข์",
          active: true,
        },
      ],
    },
  },
  {
    path: "/LawOfficer/GroupManage",
    name: "LawOfficerGroupManage",
    component: () =>
      import("@/views/Complaint/LawOfficer/LawOfficerGroupManage.vue"),
    meta: {
      pageTitle: "รายการเรื่องร้องทุกข์",
      breadcrumb: [
        { text: "กองกฎหมาย" },
        {
          text: "เจ้าหน้าที่",
        },
        {
          text: "รายการเรื่องร้องทุกข์",
          active: true,
        },
      ],
    },
  },
  {
    path: "/LawOfficer/Confirm",
    name: "LawOfficerConfirm",
    component: () =>
      import("@/views/Complaint/LawOfficer/LawOfficerConfirm.vue"),
    meta: {
      pageTitle: "รายการเรื่องร้องทุกข์",
      breadcrumb: [
        { text: "กองกฎหมาย" },
        {
          text: "เจ้าหน้าที่",
        },
        {
          text: "รายการเรื่องร้องทุกข์",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Cancelled",
    name: "Cancelled",
    component: () => import("@/views/Complaint/cancelled/Cancelled.vue"),
    meta: {
      pageTitle: "ขอยุติเรื่อง",
      breadcrumb: [
        {
          text: "คัดกรอง",
        },
        {
          text: "ขอยุติเรื่อง",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Cancelled/Manage",
    name: "CancelledManage",
    component: () => import("@/views/Complaint/cancelled/CancelledManage.vue"),
    meta: {
      pageTitle: "ขอยุติเรื่อง",
      breadcrumb: [
        {
          text: "คัดกรอง",
        },
        {
          text: "ขอยุติเรื่อง",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Forward",
    name: "Forward2",
    component: () => import("@/views/Complaint/forward/ForwardManage.vue"),
    meta: {
      pageTitle: "ส่งต่อหน่วยงานภายนอก",
      breadcrumb: [
        {
          text: "คัดกรอง",
        },
        {
          text: "ส่งต่อหน่วยงานภายนอก",
          active: true,
        },
      ],
    },
  },
  {
    path: "/consult/Manage2",
    name: "ConsultManage2",
    component: () => import("@/views/Complaint/screening/ConsultManage.vue"),
    meta: {
      pageTitle: "คัดกรอง",
      breadcrumb: [
        {
          text: "คัดกรอง",
        },
        {
          text: "จัดการเรื่องร้องทุกข์",
          active: true,
        },
      ],
    },
  },
  {
    path: "/consult/form",
    name: "ConsultForm",
    component: () => import("@/views/Complaint/screening/ConsultForm.vue"),
    meta: {
      pageTitle: "คัดกรอง",
      breadcrumb: [
        {
          text: "คัดกรอง",
        },
        {
          text: "จัดการเรื่องร้องทุกข์",
          active: true,
        },
      ],
    },
  },
  {
    path: "/consult/Confirm",
    name: "ConsultConfirm",
    component: () => import("@/views/Complaint/screening/ConsultConfirm.vue"),
    meta: {
      pageTitle: "คัดกรอง",
      breadcrumb: [
        {
          text: "คัดกรอง",
        },
        {
          text: "จัดการเรื่องร้องทุกข์",
          active: true,
        },
      ],
    },
  },
  {
    path: "/request/form",
    name: "RequestForm",
    component: () => import("@/views/Complaint/screening/RequestForm.vue"),
    meta: {
      pageTitle: "คัดกรอง",
      breadcrumb: [
        {
          text: "คัดกรอง",
        },
        {
          text: "จัดการเรื่องร้องทุกข์",
          active: true,
        },
      ],
    },
  },
  {
    path: "/request/Confirm",
    name: "RequestConfirm",
    component: () => import("@/views/Complaint/RequestConfirm.vue"),
    meta: {
      pageTitle: "ดำเนินการเรียบร้อย",
      breadcrumb: [],
    },
  },
  {
    path: "/cancelled/form",
    name: "CancelledForm",
    component: () => import("@/views/Complaint/screening/CancelledForm.vue"),
    meta: {
      pageTitle: "คัดกรอง",
      breadcrumb: [
        {
          text: "คัดกรอง",
        },
        {
          text: "จัดการเรื่องร้องทุกข์",
          active: true,
        },
      ],
    },
  },
  {
    path: "/cancelled/Confirm",
    name: "CancelledConfirm",
    component: () => import("@/views/Complaint/screening/CancelledConfirm.vue"),
    meta: {
      pageTitle: "คัดกรอง",
      breadcrumb: [
        {
          text: "คัดกรอง",
        },
        {
          text: "จัดการเรื่องร้องทุกข์",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Confirm",
    name: "Confirm",
    component: () => import("@/views/Complaint/screening/Confirm.vue"),
    meta: {
      pageTitle: "คัดกรอง",
      breadcrumb: [
        {
          text: "คัดกรอง",
        },
        {
          text: "จัดการเรื่องร้องทุกข์",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Confirm2",
    name: "Confirm2",
    component: () => import("@/views/Complaint/screening/Confirm2.vue"),
    meta: {
      pageTitle: "คัดกรอง",
      breadcrumb: [
        {
          text: "คัดกรอง",
        },
        {
          text: "จัดการเรื่องร้องทุกข์",
          active: true,
        },
      ],
    },
  },

  {
    path: "/forward/form",
    name: "ForwardForm",
    component: () => import("@/views/Complaint/screening/ForwardForm.vue"),
    meta: {
      pageTitle: "คัดกรอง",
      breadcrumb: [
        {
          text: "คัดกรอง",
        },
        {
          text: "จัดการเรื่องร้องทุกข์",
          active: true,
        },
      ],
    },
  },
  {
    path: "/forward/Confirm",
    name: "ForwardConfirm",
    component: () => import("@/views/Complaint/screening/ForwardConfirm.vue"),
    meta: {
      pageTitle: "คัดกรอง",
      breadcrumb: [
        {
          text: "คัดกรอง",
        },
        {
          text: "จัดการเรื่องร้องทุกข์",
          active: true,
        },
      ],
    },
  },

  {
    path: "/ProvincialComplaint",
    name: "ProvincialComplaint",
    component: () => import("@/views/Complaint/Provincial/complaint.vue"),
    meta: {
      pageTitle: "ศูนย์รับเรื่องราวร้องทุกข์",
      breadcrumb: [
        {
          text: "ศูนย์รับเรื่องราวร้องทุกข์",
        },
        {
          text: "รับเรื่องร้องทุกข์",
          active: true,
        },
      ],
    },
  },

  {
    path: "/ComplaintGroup",
    name: "ComplaintGroup",
    component: () =>
      import("@/views/Complaint/ComplaintGroup/complaintgroup.vue"),
    meta: {
      pageTitle: "การดำเนินการแบบเป็นกลุ่ม",
      breadcrumb: [
        {
          text: "การดำเนินการแบบเป็นกลุ่ม",
        },
        {
          text: "การดำเนินการแบบกลุ่ม",
          active: true,
        },
      ],
    },
  },
  {
    path: "/complaint",
    name: "servicecentercomplaint",
    component: () => import("@/views/Complaint/servicecenter/complaint.vue"),
    meta: {
      pageTitle: "ศูนย์รับเรื่องราวร้องทุกข์",
      breadcrumb: [
        {
          text: "ศูนย์รับเรื่องราวร้องทุกข์",
        },
        {
          text: "รับเรื่องร้องทุกข์",
          active: true,
        },
      ],
    },
  },
  {
    path: "/complaintConfirm",
    name: "servicecentercomplaintConfirm",
    component: () =>
      import("@/views/Complaint/servicecenter/complaintConfirm.vue"),
    meta: {
      pageTitle: "ศูนย์รับเรื่องราวร้องทุกข์",
      breadcrumb: [
        {
          text: "ศูนย์รับเรื่องราวร้องทุกข์",
        },
        {
          text: "รับเรื่องร้องทุกข์",
          active: true,
        },
      ],
    },
  },
  {
    path: "/complaintUpload",
    name: "servicecentercomplaintUpload",
    component: () =>
      import("@/views/Complaint/servicecenter/complaintUpload.vue"),
    meta: {
      pageTitle: "ศูนย์รับเรื่องราวร้องทุกข์",
      breadcrumb: [
        {
          text: "ศูนย์รับเรื่องราวร้องทุกข์",
        },
        {
          text: "รับเรื่องร้องทุกข์",
          active: true,
        },
      ],
    },
  },
  {
    path: "/service/attachment",
    name: "attachment",
    component: () =>
      import(
        "@/views/Complaint/servicecenter/service/attachment/Attachment.vue"
      ),
    meta: {
      pageTitle: "แนบเอกสารเพิ่มเติม",
      breadcrumb: [
        {
          text: "แนบเอกสารเพิ่มเติม",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Law/Screening",
    name: "LawScreening",
    component: () => import("@/views/Complaint/law/Screening.vue"),
    meta: {
      pageTitle: "คัดกรอง",
      breadcrumb: [
        {
          text: "คัดกรอง",
        },
        {
          text: "คัดกรองเรื่องร้องทุกข์",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Law/ScreeningManage",
    name: "LawScreeningManage",
    component: () => import("@/views/Complaint/law/ScreeningManage.vue"),
    meta: {
      pageTitle: "คัดกรอง",
      breadcrumb: [
        {
          text: "คัดกรอง",
        },
        {
          text: "จัดการเรื่องร้องทุกข์",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Law/GroupManage",
    name: "LawGroupdManage",
    component: () => import("@/views/Complaint/law/GroupManage.vue"),
    meta: {
      pageTitle: "สร้างกลุ่มร้องทุกข์",
      breadcrumb: [
        {
          text: "สร้างกลุ่มร้องทุกข์",
        },
        {
          text: "สร้างกลุ่มร้องทุกข์",
          active: true,
        },
      ],
    },
  },
  {
    path: "/complaint/completed",
    name: "servicecentercomplaintcompleted",
    component: () => import("@/views/Complaint/servicecenter/completed.vue"),
    meta: {
      pageTitle: "ศูนย์รับเรื่องราวร้องทุกข์",
      breadcrumb: [
        {
          text: "ศูนย์รับเรื่องราวร้องทุกข์",
        },
        {
          text: "รับเรื่องร้องทุกข์",
          active: true,
        },
      ],
    },
  },
  {
    path: "/provoff",
    name: "provoff",
    component: () => import("@/views/Complaint/provoff/provoff.vue"),
    meta: {
      pageTitle: "จังหวัด",
      breadcrumb: [
        {
          text: "จังหวัด",
        },
        {
          text: "จังหวัด",
          active: true,
        },
      ],
    },
  },
  {
    path: "/provoff/Manage",
    name: "provoffManage",
    component: () => import("@/views/Complaint/provoff/provoffManage.vue"),
    meta: {
      pageTitle: "จังหวัด",
      breadcrumb: [
        {
          text: "จังหวัด",
        },
        {
          text: "จังหวัด",
          active: true,
        },
      ],
    },
  },
  {
    path: "/provoff/Confirm",
    name: "provoffConfirm",
    component: () => import("@/views/Complaint/provoff/provoffConfirm.vue"),
    meta: {
      pageTitle: "จังหวัด",
      breadcrumb: [
        {
          text: "จังหวัด",
        },
        {
          text: "จังหวัด",
          active: true,
        },
      ],
    },
  },
  // *===============================================---*
  // *--------- EMAIL & IT'S FILTERS N LABELS -------------------------------*
  // *===============================================---*
  {
    path: "/apps/email",
    name: "apps-email",
    component: () => import("@/views/apps/email/Email.vue"),
    meta: {
      contentRenderer: "sidebar-left",
      contentClass: "email-application",
    },
  },
  {
    path: "/apps/email/:folder",
    name: "apps-email-folder",
    component: () => import("@/views/apps/email/Email.vue"),
    meta: {
      contentRenderer: "sidebar-left",
      contentClass: "email-application",
      navActiveLink: "apps-email",
    },
    beforeEnter(to, _, next) {
      if (
        ["sent", "draft", "starred", "spam", "trash"].includes(to.params.folder)
      )
        next();
      else next({ name: "error-404" });
    },
  },
  {
    path: "/apps/email/label/:label",
    name: "apps-email-label",
    component: () => import("@/views/apps/email/Email.vue"),
    meta: {
      contentRenderer: "sidebar-left",
      contentClass: "email-application",
      navActiveLink: "apps-email",
    },
    beforeEnter(to, _, next) {
      if (
        ["personal", "company", "important", "private"].includes(
          to.params.label
        )
      )
        next();
      else next({ name: "error-404" });
    },
  },

  // *===============================================---*
  // *--------- TODO & IT'S FILTERS N TAGS ---------------------------------------*
  // *===============================================---*
  {
    path: "/apps/todo",
    name: "apps-todo",
    component: () => import("@/views/apps/todo/Todo.vue"),
    meta: {
      contentRenderer: "sidebar-left",
      contentClass: "todo-application",
    },
  },
  {
    path: "/apps/todo/:filter",
    name: "apps-todo-filter",
    component: () => import("@/views/apps/todo/Todo.vue"),
    meta: {
      contentRenderer: "sidebar-left",
      contentClass: "todo-application",
      navActiveLink: "apps-todo",
    },
    beforeEnter(to, _, next) {
      if (["important", "completed", "deleted"].includes(to.params.filter))
        next();
      else next({ name: "error-404" });
    },
  },
  {
    path: "/apps/todo/tag/:tag",
    name: "apps-todo-tag",
    component: () => import("@/views/apps/todo/Todo.vue"),
    meta: {
      contentRenderer: "sidebar-left",
      contentClass: "todo-application",
      navActiveLink: "apps-todo",
    },
    beforeEnter(to, _, next) {
      if (["team", "low", "medium", "high", "update"].includes(to.params.tag))
        next();
      else next({ name: "error-404" });
    },
  },

  // *===============================================---*
  // *--------- CHAT  ---------------------------------------*
  // *===============================================---*
  {
    path: "/apps/chat",
    name: "apps-chat",
    component: () => import("@/views/apps/chat/Chat.vue"),
    meta: {
      contentRenderer: "sidebar-left",
      contentClass: "chat-application",
    },
  },

  // *===============================================---*
  // *--------- ECOMMERCE  ---------------------------------------*
  // *===============================================---*
  {
    path: "/apps/e-commerce/shop",
    name: "apps-e-commerce-shop",
    component: () =>
      import("@/views/apps/e-commerce/e-commerce-shop/ECommerceShop.vue"),
    meta: {
      contentRenderer: "sidebar-left-detached",
      contentClass: "ecommerce-application",
      pageTitle: "Shop",
      breadcrumb: [
        {
          text: "ECommerce",
        },
        {
          text: "Shop",
          active: true,
        },
      ],
    },
  },
  {
    path: "/apps/e-commerce/wishlist",
    name: "apps-e-commerce-wishlist",
    component: () =>
      import(
        "@/views/apps/e-commerce/e-commerce-wishlist/ECommerceWishlist.vue"
      ),
    meta: {
      pageTitle: "Wishlist",
      contentClass: "ecommerce-application",
      breadcrumb: [
        {
          text: "ECommerce",
        },
        {
          text: "Wishlist",
          active: true,
        },
      ],
    },
  },
  {
    path: "/apps/e-commerce/checkout",
    name: "apps-e-commerce-checkout",
    component: () =>
      import(
        "@/views/apps/e-commerce/e-commerce-checkout/ECommerceCheckout.vue"
      ),
    meta: {
      pageTitle: "Checkout",
      contentClass: "ecommerce-application",
      breadcrumb: [
        {
          text: "ECommerce",
        },
        {
          text: "Checkout",
          active: true,
        },
      ],
    },
  },
  {
    path: "/apps/e-commerce/:slug",
    name: "apps-e-commerce-product-details",
    component: () =>
      import(
        "@/views/apps/e-commerce/e-commerce-product-details/ECommerceProductDetails.vue"
      ),
    meta: {
      pageTitle: "Product Details",
      contentClass: "ecommerce-application",
      breadcrumb: [
        {
          text: "ECommerce",
        },
        {
          text: "Shop",
          active: true,
        },
        {
          text: "Product Details",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ReportSummary/ComplaintSend",
    name: "ComplaintSendSummary",
    component: () =>
      import("@/views/Complaint/ComplaintSendSummary/ComplaintSendSummary.vue"),
    meta: {
      pageTitle: "รายการส่งเรื่องร้องทุกข์",
      breadcrumb: [
        {
          text: "รายการส่งเรื่องร้องทุกข์",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ReportSummary/ComplaintReceived",
    name: "ComplaintReceivedSummary",
    component: () =>
      import(
        "@/views/Complaint/ComplaintReceivedSummary/ComplaintReceivedSummary.vue"
      ),
    meta: {
      pageTitle: "รายการรับเรื่องร้องทุกข์",
      breadcrumb: [
        {
          text: "รายการรับเรื่องร้องทุกข์",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ReportSummary/ComplaintScreeningSend",
    name: "ComplaintScreeningSendSummary",
    component: () =>
      import(
        "@/views/Complaint/ComplaintScreeningSendSummary/ComplaintScreeningSendSummary.vue"
      ),
    meta: {
      pageTitle: "รายการส่งเรื่องร้องทุกข์",
      breadcrumb: [
        {
          text: "รายการส่งเรื่องร้องทุกข์",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ReportSummary/ComplaintScreeningReceived",
    name: "ComplaintScreeningReceivedSummary",
    component: () =>
      import(
        "@/views/Complaint/ComplaintScreeningReceivedSummary/ComplaintScreeningReceivedSummary.vue"
      ),
    meta: {
      pageTitle: "รายการรับเรื่องร้องทุกข์",
      breadcrumb: [
        {
          text: "รายการรับเรื่องร้องทุกข์",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ReportSummary/ComplaintPersonal",
    name: "ComplaintPersonalSummary",
    component: () =>
      import(
        "@/views/Complaint/ComplaintPersonalSummary/ComplaintPersonalSummary.vue"
      ),
    meta: {
      pageTitle: "รายการรับ-ส่งเรื่องร้องทุกข์รายบุคคล",
      breadcrumb: [
        {
          text: "รายการรับ-ส่งเรื่องร้องทุกข์รายบุคคล",
          active: true,
        },
      ],
    },
  },

  //---MeidateSection----//
  {
    path: "/SubCommitteeInvitation",
    name: "SubCommitteeInvitation",
    component: () =>
      import(
        "@/views/Complaint/SubCommitteeInvitation/SubCommitteeInvitation.vue"
      ),
    meta: {
      pageTitle: "จดหมายเชิญอนุกรรมการ",
      breadcrumb: [
        {
          text: "จดหมายเชิญอนุกรรมการ",
          active: true,
        },
      ],
    },
  },
  {
    path: "/SubCommitteeInvitation/Manage",
    name: "SubCommitteeInvitationManage",
    component: () =>
      import(
        "@/views/Complaint/SubCommitteeInvitation/SubCommitteeInvitationManage.vue"
      ),
    meta: {
      pageTitle: "จดหมายเชิญอนุกรรมการ",
      breadcrumb: [
        {
          text: "จดหมายเชิญอนุกรรมการ",
          active: false,
        },
        {
          text: "เพิ่ม/แก้ไข",
          active: true,
        },
      ],
    },
  },
  {
    path: "/SubCommitteeApprove",
    name: "SubCommitteeApprove",
    component: () =>
      import(
        "@/views/Complaint/SubCommitteeApprove/SubCommitteeApprove.vue"
      ),
    meta: {
      pageTitle: "อนุมัติจดหมายเชิญอนุกรรมการ",
      breadcrumb: [
        {
          text: "อนุมัติจดหมายเชิญอนุกรรมการ",
          active: true,
        },
      ],
    },
  },
  {
    path: "/SubCommittee",
    name: "SubCommittee",
    component: () =>
      import(
        "@/views/Complaint/MediateDirector/MediateDirector.vue"
      ),
    meta: {
      pageTitle: "จัดการอนุกรรมการ",
      breadcrumb: [
        {
          text: "จัดการอนุกรรมการ",
          active: true,
        },
      ],
    },
  },
  {
    path: "/SubCommittee/Manage",
    name: "MediateDirectorManage",
    component: () =>
      import(
        "@/views/Complaint/MediateDirector/MediateDirectorManage.vue"
      ),
    meta: {
      pageTitle: "จัดการอนุกรรมการ",
      breadcrumb: [
        {
          text: "จัดการอนุกรรมการ",
          active: false,
        },
        {
          text: "เพิ่ม/แก้ไข",
          active: true,
        },
      ],
    },
  },
  {
    path: "/SubCommitteeGroup",
    name: "SubCommitteeGroup",
    component: () =>
      import(
        "@/views/Complaint/MediateDirectorGroup/MediateDirectorGroup.vue"
      ),
    meta: {
      pageTitle: "จัดการกลุ่มอนุกรรมการ",
      breadcrumb: [
        {
          text: "จัดการกลุ่มอนุกรรมการ",
          active: true,
        },
      ],
    },
  },
  {
    path: "/SubCommitteeGroup/Manage",
    name: "MediateDirectorGroupManage",
    component: () =>
      import(
        "@/views/Complaint/MediateDirectorGroup/MediateDirectorGroupManage.vue"
      ),
    meta: {
      pageTitle: "จัดการกลุ่มอนุกรรมการ",
      breadcrumb: [
        {
          text: "จัดการกลุ่มอนุกรรมการ",
          active: false,
        },
        {
          text: "เพิ่ม/แก้ไข",
          active: true,
        },
      ],
    },
  },


  // *===============================================---*
  // *--------- USER ---- ---------------------------------------*
  // *===============================================---*
  {
    path: "/apps/users/list",
    name: "apps-users-list",
    component: () => import("@/views/apps/user/users-list/UsersList.vue"),
  },
  {
    path: "/apps/users/view/:id",
    name: "apps-users-view",
    component: () => import("@/views/apps/user/users-view/UsersView.vue"),
  },
  {
    path: "/apps/users/edit/:id",
    name: "apps-users-edit",
    component: () => import("@/views/apps/user/users-edit/UsersEdit.vue"),
  },

  // Invoice
  {
    path: "/apps/invoice/list",
    name: "apps-invoice-list",
    component: () =>
      import("@/views/apps/invoice/invoice-list/InvoiceList.vue"),
  },
  {
    path: "/apps/invoice/preview/:id",
    name: "apps-invoice-preview",
    component: () =>
      import("@/views/apps/invoice/invoice-preview/InvoicePreview.vue"),
  },
  {
    path: "/apps/invoice/add/",
    name: "apps-invoice-add",
    component: () => import("@/views/apps/invoice/invoice-add/InvoiceAdd.vue"),
  },
  {
    path: "/apps/invoice/edit/:id",
    name: "apps-invoice-edit",
    component: () =>
      import("@/views/apps/invoice/invoice-edit/InvoiceEdit.vue"),
  },
];
